// extracted by mini-css-extract-plugin
module.exports = {"day-group":"WeeksDaysPicker_day-group__31NTM","day-name":"WeeksDaysPicker_day-name__3xsZy"};